"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyPromocode = verifyPromocode;
var _ = require("./");
function verifyPromocode(_ref) {
  var promocode = _ref.promocode,
    patientId = _ref.patientId;
  return _.apiWithoutErrorsHandler.get((0, _.getDiscountedPricesUrl)(patientId, promocode.trim()));
}